import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RulebookSummary } from 'src/app/core/models/rulebook/rulebook-summary';
import { ToastViewModel } from 'src/app/core/models/view-model';
import { GDPRService } from 'src/app/core/services/rulebook';

@Component({
  selector: 'app-rulebook-summary',
  templateUrl: './rulebook-summary.component.html',
  styleUrls: ['./rulebook-summary.component.scss']
})
export class RulebookSummaryComponent implements OnInit {
  summaryData: Array<RulebookSummary> = [];
  summeryLoading:boolean=false;
  isGenerateDisabled: boolean = false;
  toastModel!: ToastViewModel;
  isToastShow = false;
  constructor(@Inject(MAT_DIALOG_DATA) public data: { data: Array<any>,type: string, id: number },
    public dialogRefSummary: MatDialogRef<RulebookSummaryComponent>,
    private gdprService: GDPRService)
  {
    this.summaryData = data.data;
  }

  ngOnInit(): void {
  }
  async onCloseDialog(id: number) {
    await this.dialogRefSummary.close(id);
  }
  async generateSummary() {
    this.summeryLoading = true;
    this.isGenerateDisabled=true;
    this.gdprService.generateSummary(this.data.id, this.data.type)
      .subscribe((data: any) => {
        this.getSummary(this.data.id, this.data.type);
      })

  }
  getSummary(id: number, type: string) {
    this.gdprService.getSummary(id, type)
      .subscribe((data: Array<RulebookSummary>) => {
        this.summaryData = data;
        this.summeryLoading = false;
        this.successAlert("Generate Successfully");
        this.isGenerateDisabled=false;
      })
  }
  showText(description: string): any {
    if (description) {
      const descArr = description.split('\n');
      const strArr = new Array<string>();
      descArr.forEach(item => {
        if (item) {
          strArr.push('<p>' + item + '</p>');
        }
      });
      description = strArr.join(' ');
    }
    return description;
  }
  successAlert(text: string): void {
    this.toastModel.Title = 'Success';
    this.toastModel.Type = 'success';
    this.toastModel.Message = text;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 3000);
  }


}
